export interface LogOptions {
  useBuffer: boolean;
  requestInterval: number;
  recordsLimit: number;
}

export interface LogSenderInfo {
  table: string;
  env: string;
}

export enum BufferStorage {
  LOCAL_STORAGE = 'LOCAL_STORAGE',
  COOKIE_STORAGE = 'COOKIE_STORAGE',
}